import { useEffect, useRef } from 'react';

/** Telegram BackButton — permanently disabled (broke SPA navigation). */
export function useTelegramBackButton() {
  useEffect(() => {
    const back = window.Telegram?.WebApp?.BackButton;
    if (!back) return undefined;
    try {
      back.hide?.();
    } catch (_) {
      /* ignore */
    }
    return () => {
      try {
        back.hide?.();
      } catch (_) {
        /* ignore */
      }
    };
  }, []);
}

/** Telegram MainButton — stable onClick via ref to avoid flicker. */
export function useTelegramMainButton({ label, onClick, show = false } = {}) {
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  useEffect(() => {
    const main = window.Telegram?.WebApp?.MainButton;
    if (!main) return undefined;

    if (!show || !label) {
      main.hide?.();
      return undefined;
    }

    try {
      main.setText?.(label);
      main.show?.();
      main.enable?.();
    } catch (_) {
      /* ignore */
    }

    const handler = () => onClickRef.current?.();
    main.onClick?.(handler);
    return () => {
      try {
        main.offClick?.(handler);
      } catch (_) {
        /* ignore */
      }
      main.hide?.();
    };
  }, [show, label]);
}
